<template>
<div>
    <div class="form-group">
        <label class="mt-1" for="labelPrice"><strong>Descrizione estesa </strong></label>
         <div class="input-group mb-2">

        <!--    
         <div class="input-group-prepend">
          <div class="input-group-text"></div>
        </div>
        -->
        <div class="form-group">
        <textarea  @input="$emit('update',$event.target.value)" v-model="description" class="form-control" id="w3review" name="w3review" rows="10" cols="120" >
          
        </textarea>
        </div>
        <!--<input @input="$emit('update',$event.target.value)" v-model="description" type="text" class="form-control" placeholder="" name="description" id = "description">    -->
         </div>
    </div>    
</div>

</template>
<script>
//import axios             from "axios";

export default {
  props : ['_description'] , 
  components: {},
  data() {
    return {

      description : this._description
    };
  },
  mounted: function() {
      //this.description =this._description
  },
  created: function() {
     
  },
  methods: 
  {

  }

}
</script>
<style scoped>
textarea {
  resize: auto;
}
</style>